module.exports = __webpack_public_path__ + "dimer/static/img/22.e313cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/22.jpg
// module id = e9hx
// module chunks = 0